import { Component, OnInit } from '@angular/core';
import {ConfService} from '../conf.service';
import {Router} from '@angular/router';
import {LeftpanelComponent, LoaderWithProgressComponent} from '../leftpanel/leftpanel.component';
import {KongService} from '../kong.service';
import {MatDialog, MatDialogRef} from '@angular/material';
@Component({
    selector: 'app-landing-page',
    templateUrl: './landing-page.component.html',
    styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent implements OnInit {

    partnerShortCode: any;
    partnerAccount: any;
    apikey: any;
    data1: any;
    data: any;
    environments: any;
    isDevPresent = false;
    isAdmin = false;
    loading = true;
    apiKeys: any;
    apiKeyData: any;
    apiKey: any;
    isAdminForPartnerAvailable = false;

    constructor(private confPost: ConfService,
                private router: Router,
                public platform: LeftpanelComponent,
                public dialog: MatDialog,
                private kong: KongService) {
    }

    async ngOnInit() {

        if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
            this.platform.initialisePlatform();
        }

        const temp = localStorage.getItem('partner').split('-');
        const temp1 = localStorage.getItem('account').split('-');

        if (temp.length > 1) {
            this.partnerShortCode = temp[temp.length - 1];
            if (temp[0] === 'admin') {
                this.isAdmin = true;
            }
        } else {
            this.partnerShortCode = localStorage.getItem('partner');
        }
        if (temp1.length > 1) {
            this.partnerAccount = temp1[temp1.length - 1];
        } else {
            this.partnerAccount = localStorage.getItem('partner');
        }

        if (localStorage.getItem('apikey')) {
            this.apiKey = localStorage.getItem('apikey');
        } else {
            await this.getApiKeyForUser(localStorage.getItem('signInEmail'));
            this.loading = false;
        }

        if (this.isAdmin) {
            this.confPost.getSettingsV2CRUD(localStorage.getItem('partner'), localStorage.getItem('account'), false)
                .subscribe(data => {
                    if (data && data['body'][0]) {
                        if (data['body'][0]['environments'].length === 1 && data['body'][0]['environments'][0]['type'] === 'admin') {
                            this.isDevPresent = false;
                        } else {
                            this.isDevPresent = true;
                        }
                    }
                    this.loading = false;

                    // this.confPost.getSettingsV2CRUD('dev-' + this.partnerShortCode, 'dev-' + this.partnerAccount, false).subscribe(resp => {
                    //     if (resp['body'] && resp['body'][0]) {
                    //         this.isDevPresent = true;
                    //         this.loading = false;
                    //     } else {
                    //         this.loading = false;
                    //     }
                    // }, error => {
                    //     this.loading = false;
                    // });
                    // this.confPost.getSettingsV2CRUD(localStorage.getItem('partner'), localStorage.getItem('account'), false)
                    //     .subscribe(data1 => {
                    //         this.data1 = data1['body'][0];
                    //         if (data1['body'][0] && data1['body'][0]['environments'] !== undefined ) {
                    //             this.environments = data1['body'][0]['environments'];
                    //             for (const env of this.environments) {
                    //                 if (env['type'] === 'dev') {
                    //                     this.isDevPresent = true;
                    //                 }
                    //             }
                    //             this.loading = false;
                    //         } else {
                    //             this.loading = false;
                    //         }
                    //     }, error => {
                    //         this.loading = false;
                    //     });
                }, error => {
                    this.loading = false;
                });
        } else {
            const params = {'API-PLATFORM-PARTNER': localStorage.getItem('partner'), 'API-PLATFORM-PARTNER-KEY': localStorage.getItem('partnerKey'), 'dbref': false}
            this.confPost.getPlatformData('v1', 'validate-partner', params).subscribe(result => {
                if (result && result['body']) {
                    this.isAdminForPartnerAvailable = result['body']['response'];
                    // if (this.isAdminForPartnerAvailable === true) {
                    //     this.loading = false;
                    // }
                    // else {
                    // this.confPost.getSettingsCRUD('admin-' + this.partnerShortCode, 'admin-' + this.partnerAccount).subscribe(response => {
                    //     if (response && response[0] && response[0]['environments']) {
                    //         this.isAdminForPartnerAvailable = true;
                    //     } else {
                    //         this.isAdminForPartnerAvailable = false;
                    //     }
                    //     this.loading = false;
                    // }, error => {
                    //     this.loading = false;
                    // });
                    // }
                    this.confPost.getSettingsV2CRUD('admin-' + this.partnerShortCode, 'admin-' + this.partnerAccount, false).subscribe(resp => {
                        let isEnvPresentInAdmin = false;
                        let counter = 0;
                        if (resp['body'] && resp['body'][0]) {
                            const envCountInAdmin = resp['body'][0]['environments'].length;
                            resp['body'][0]['environments'].forEach(environment => {
                                counter += 1;
                                if (environment['name'] === localStorage.getItem('partner')) {
                                    isEnvPresentInAdmin = true;
                                }
                                if (counter === envCountInAdmin && isEnvPresentInAdmin === false) {
                                    this.confPost.getSettingsV2CRUD(localStorage.getItem('partner'), localStorage.getItem('account'), false).subscribe(resp1 => {
                                        if (resp1['body'] && resp1['body'][0]) {
                                            resp['body'][0]['environments'].push(resp1['body'][0]['environments'][0]);
                                            this.confPost.patchEntityData('services', 'services', 'v2', 'settings', resp['body'][0]['id'], resp['body'][0]).subscribe(resp2 => {

                                            }, error => {

                                            });
                                        }
                                    });
                                }
                            });
                        }
                        this.loading = false;
                    }, error => {
                        this.loading = false;
                    });
                } else {
                    this.loading = false;
                    this.isAdminForPartnerAvailable = false;
                }
            }, error => {
                this.loading = false;
            });
        }
    }

    getApiKeyForUser(signInEmail) {
        return new Promise((resolve, reject) => {
            this.kong.getKeyAuthForConsumerInApiGatewayByNameOrId(signInEmail).subscribe(keys => {
                this.apiKeyData = keys;
                if (this.apiKeyData.data !== null && this.apiKeyData.data !== undefined && this.apiKeyData.data.length !== 0) {
                    this.apiKeys = this.apiKeyData.data;
                    this.apiKey = this.apiKeys[0].key;
                    localStorage.setItem('apikey', this.apiKey);
                } else {
                    this.platform.openSnackBar('There is no API key associated to your user credentials. Please get an API Key to securely access your APIs.', 'Info', {
                        duration: 10000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }
                resolve('success');
            }, error => {
                this.platform.openSnackBar('There is no API key associated to your user credentials. Please get an API Key to securely access your APIs.', 'Info', {
                    duration: 10000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                resolve('failed');
            });
        });
    }

    getDevEnvironment() {
        this.platform.isDevEnvironmentFromAdmin = true;
        this.router.navigateByUrl('/add-environment');
    }
    getSuperAdminEnvironment() {
        this.platform.isAdminForPartner = true;
        this.router.navigateByUrl('/add-environment');
    }
    createApiKey() {
        const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
            width: 'auto',
            height: 'auto',
            data: {
                message: ''
            }
        });
        const consumerData = {
            'username': localStorage.getItem('signInEmail'),
            // 'custom_id': this.partnerAccount
            'custom_id': localStorage.getItem('signInEmail')
        };
        const key = {
            value: ''
        };

        const body = key.value ? {key: key.value} : {};
        this.kong.createConsumerInApiGateway(consumerData).subscribe(async cons => {
            this.createKey(loaderDialog, cons['id'], body);
        }, error1 => {
            if (error1 && error1.status === 409) {
                this.kong.getConsumersInApiGatewayByNameOrId(consumerData['username']).subscribe(response => {
                    this.createKey(loaderDialog, response['id'], body);
                }, error => {
                    loaderDialog.close();
                    this.platform.handleErrorGracefully(error, 'Error while creating API Key for user : ' + localStorage.getItem('signInEmail') + '. ' + this.platform.returnErrorMessage(error));
                });
            } else {
                loaderDialog.close();
                this.platform.handleErrorGracefully(error1, 'Error while creating API Key for user : ' + localStorage.getItem('signInEmail') + '. ' + this.platform.returnErrorMessage(error1));
            }
        });
    }

    createKey(loaderDialog: MatDialogRef<LoaderWithProgressComponent>, id, body) {
        this.kong.provisionKeyAuthToConsumerInApiGatewayByNameOrId(id, body).subscribe(async res => {
            this.platform.openSnackBar('API Key is provisioned successfully for the user: ' + localStorage.getItem('signInEmail'), 'Success', {
                duration: 15000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
            localStorage.setItem('apikey', res['key']);
            loaderDialog.close();
            window.location.reload();
        }, error => {
            loaderDialog.close();
            this.platform.handleErrorGracefully(error, 'Error while provisioning API Key for user : ' + localStorage.getItem('signInEmail') + '. ' + this.platform.returnErrorMessage(error));
        });
    }
}
